import { skipToken, useQuery } from '@tanstack/react-query';

import { importsApi } from '../api/imports-api';

import { jobKeys } from './job-keys';

/** The job behind the errors drawer; null while the drawer is closed. */
export function useImportJob(storeId: string, id: string | null) {
  return useQuery({
    queryKey: jobKeys.importDetail(storeId, id ?? 'none'),
    queryFn: id ? () => importsApi.get(storeId, id) : skipToken,
  });
}
